<template>
  <div class="group-deal-message">
    {{ message }}

    <form @submit.prevent="submitEmail">
      <input
        :disabled="isLoading"
        type="email"
        class="referral-input white-bg"
        placeholder="master@ninja.com"
        v-model="email"
      />
      <button :class="['box-button', { loading: isLoading }]" type="submit">
        <div v-if="isLoading" class="lds-facebook">
          <div></div>
          <div></div>
          <div></div>
        </div>
        <div v-else>Submit</div>
      </button>
    </form>
    <div class="message-wrapper" v-if="submitMessage">
      <div class="message">
        {{ submitMessage }}
      </div>
    </div>
  </div>
</template>

<script>
import * as emailValidator from 'email-validator'
const plansPageMsg = `Programs and plans for classes are coming soon. Stay informed of our updates by entering your email.`
const notReadyMessage = `We're sorry, but this page is not ready yet. We'll be sure to message you when we're ready if you 
provide us with your email.`

export default {
  name: 'SignupComp',
  data() {
    return {
      email: '',
      submitMessage: '',
      currentTimeout: null,
      isLoading: false,
    }
  },
  computed: {
    isPlansPage() {
      return this.$route.path === '/plans'
    },
    message() {
      return this.isPlansPage ? plansPageMsg : notReadyMessage
    },
  },
  methods: {
    submitEmail() {
      const isValid = emailValidator.validate(this.email)
      if (isValid) {
        this.isLoading = true
        this.db
          .collection('email-leads')
          .add({
            email: this.email,
            type: this.isPlansPage ? 'class-interest' : 'regular-interest',
            place: this.$route.path,
            timestamp: new Date(),
          })
          .then(() => {
            this.submitMessage = `Email registered successfully!`
            this.email = ''
          })
          .catch((e) => {
            console.log(e)
            this.submitMessage = `Email registered failed.`
          })
          .finally(() => {
            this.isLoading = false
            this.removeSubmitMessage()
          })
      } else {
        this.submitMessage = `Invalid email.`
        this.removeSubmitMessage()
      }
    },
    removeSubmitMessage() {
      this.currentTimeout && clearTimeout(this.currentTimeout)
      this.currentTimeout = setTimeout(() => {
        this.submitMessage = ''
      }, 5000)
    },
  },
}
</script>

<style scoped lang="scss">
.group-deal-message {
  margin: 50px auto 0;
  background: gainsboro;
  padding: 20px;
  box-sizing: border-box;
  max-width: 400px;
  border: 2px black dashed;

  input {
    width: 100%;
    margin-top: 20px;
  }

  button {
    width: 200px;
    margin: 10px auto 0;
    display: block;
    width: 100%;
    background: $color-primary-2;
    color: white;
    padding: 10px;
    margin: 20px 0 0;
    border-radius: 3px;
    outline: none;
    font-size: 14px;

    &:active,
    &:hover {
      background: $color-primary-3;
    }
  }
}

.message-wrapper {
  position: fixed;
  width: 100vw;
  bottom: 0;
  left: 0;
  display: flex;
  padding: 20px;
  justify-content: center;

  .message {
    background: gray;
    padding: 10px;
    color: white;
    text-align: center;
    width: 100%;
    max-width: 300px;
    border-radius: 25px;
  }
}
</style>
